<template>
  <div class="recharge-claim">
    <img :src="smileyUrl" class="recharge-claim__smiley" alt="" />

    <div class="recharge-claim__card">
      <div class="recharge-claim__content">
        <div class="recharge-claim__top-bar">
          <img :src="topBarBgUrl" class="recharge-claim__top-bar-bg" alt="" />
          <span class="recharge-claim__top-label">{{ viewData.topLabel }}</span>
        </div>

        <img
          :src="bubbleRightUrl"
          class="recharge-claim__bubble recharge-claim__bubble--right"
          alt=""
        />
        <img
          :src="bubbleLeftMiddleUrl"
          class="recharge-claim__bubble recharge-claim__bubble--left-middle"
          alt=""
        />
        <img
          :src="bubbleLeftBottomUrl"
          class="recharge-claim__bubble recharge-claim__bubble--left-bottom"
          alt=""
        />

        <h2
          class="recharge-claim__title"
          :class="{ 'recharge-claim__title--normal': !viewData.titleUppercase }"
        >
          {{ viewData.title }}
        </h2>

        <p class="recharge-claim__desc">
          {{ viewData.descBefore }}
          <span class="recharge-claim__desc-highlight">{{ viewData.descHighlight }}</span>
          {{ viewData.descAfter }}
        </p>

        <button
          type="button"
          class="recharge-claim__action"
          :class="{ 'recharge-claim__action--neon-loading': depositLoading }"
          :disabled="depositLoading"
          @click="handlePrimaryClick"
        >
          <span v-if="depositLoading" class="recharge-claim__loading" aria-live="polite">
            <span
              v-for="(ch, index) in loadingChars"
              :key="`${ch}-${index}`"
              class="recharge-claim__loading-char"
              :style="{ '--char-index': index }"
            >
              {{ ch }}
            </span>
          </span>
          <template v-else>
            {{ viewData.primaryButton }}
          </template>
        </button>

        <button
          type="button"
          class="recharge-claim__later"
          :disabled="depositLoading"
          @click="handleLater"
        >
          {{ viewData.secondaryButton }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { RECHARGE_CLAIM_TYPE, useRechargeClaim } from './js/index.js'

const props = defineProps({
  type: {
    type: String,
    default: RECHARGE_CLAIM_TYPE.RECHARGE,
    validator: (value) => Object.values(RECHARGE_CLAIM_TYPE).includes(value),
  },
  totalBonus: {
    type: Number,
    default: 28,
  },
  depositAmount: {
    type: Number,
    default: 10,
  },
  /** 充值请求 loading（由父级控制） */
  depositLoading: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'deposit', 'goHome'])

/** 与签到弹窗主按钮一致的 Loading 打字动画字符 */
const loadingChars = 'Loading'.split('')

const {
  topBarBgUrl,
  smileyUrl,
  bubbleRightUrl,
  bubbleLeftBottomUrl,
  bubbleLeftMiddleUrl,
  viewData,
  handlePrimaryClick,
  handleLater,
} = useRechargeClaim(props, emit)
</script>

<style lang="less" scoped src="./css/index.less"></style>
